import type { MemberElectionRunNode } from "../../types";
import { MEMBER_ELECTIONS_PAST_PRESIDENTS_PATH } from "../../constants";

export type PastPresidentsRosterDownloadContext = {
  electionRunId?: string;
  electionRunIds?: string[];
};

export type PastPresidentsRosterNavigationState = {
  electionRuns?: Pick<MemberElectionRunNode, "startedAt" | "completedAt">[];
};

export function buildPastPresidentsRosterPath(runs: MemberElectionRunNode[]): {
  pathname: string;
  search: string;
  state: PastPresidentsRosterNavigationState;
} {
  if (runs.length === 1) {
    return {
      pathname: MEMBER_ELECTIONS_PAST_PRESIDENTS_PATH,
      search: `?electionRunId=${encodeURIComponent(runs[0].id)}`,
      state: { electionRuns: [runs[0]] }
    };
  }

  const ids = runs.map((run) => run.id).join(",");
  return {
    pathname: MEMBER_ELECTIONS_PAST_PRESIDENTS_PATH,
    search: `?electionRunIds=${encodeURIComponent(ids)}`,
    state: { electionRuns: runs }
  };
}

export function parsePastPresidentsRosterSearch(search: string): PastPresidentsRosterDownloadContext {
  const params = new URLSearchParams(search);
  const electionRunId = params.get("electionRunId") ?? undefined;
  const electionRunIdsParam = params.get("electionRunIds");
  const electionRunIds =
    electionRunIdsParam && electionRunIdsParam.length > 0
      ? electionRunIdsParam
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean)
      : undefined;

  if (electionRunIds && electionRunIds.length > 0) {
    return { electionRunIds };
  }

  return { electionRunId };
}
